import { AlacakKalemiAlani } from "@/enum/AlacakKalemiAlani";

interface SiralanabilirAlan {
  id: number;
  [key: string]: any;
}

/**
 * Kapak hesabındaki takip sonrası kalem sırası, kalemlerin oluşma sırasından gelir.
 * KDV kalemi onay kutusu işaretlendiğinde sonradan yaratıldığı için listenin sonuna
 * (Harç / Masraf'ın altına) düşüyor. Vergi kalemi olarak BSMV'nin hemen altında,
 * BSMV yoksa Takip Sonrası Faiz'in hemen altında durması gerekir.
 *
 * Diziyi yerinde değiştirmez, sıralanmış yeni bir dizi döner.
 */
export function kdvyiBsmvAltinaAl<T extends SiralanabilirAlan>(alanlar: Array<T>): Array<T> {
  const sirali = alanlar.slice();

  const kdvIndex = sirali.findIndex((alan) => alan.id === AlacakKalemiAlani.takipSonrasiKdv);
  if (kdvIndex < 0) {
    return sirali;
  }

  const [kdv] = sirali.splice(kdvIndex, 1);

  // BSMV yoksa (onay kutusu kapalıyken kalem üretilmez) faizin altına konur.
  let ankraj = sirali.findIndex((alan) => alan.id === AlacakKalemiAlani.takipSonrasiBsmv);
  if (ankraj < 0) {
    ankraj = sirali.findIndex((alan) => alan.id === AlacakKalemiAlani.takipSonrasiFaiz);
  }

  if (ankraj < 0) {
    // Tutunacak satır yok; KDV eski yerinde kalsın.
    sirali.splice(kdvIndex, 0, kdv);
    return sirali;
  }

  sirali.splice(ankraj + 1, 0, kdv);
  return sirali;
}
